export default function Timer() {
    return (<div style={{
        left: 0,
        width: "100%",
        height: "300px",
        position: "relative",
        paddingBottom: 0,
        margin: "0 auto"
    }}>
        <iframe src="https://www.tickcounter.com/widget/countdown/6248177" style={{
            top: 0,
            left: 0,
            width: "100%",
            height: "100%",
            position: "absolute",
            border: 0,
            overflow: "hidden"
        }} title="Meti &amp; Bervi"></iframe></div>);
}